import JQuery from 'jquery';
window.$ = window.jQuery = JQuery;

$(function(){
  var urlParams = new URLSearchParams(window.location.search);
  function searchUrl() {
    let data = getSearchConditions();
    let keyword = $.trim($("#job_search_form_keyword").val());
    let url = decodeURIComponent(Routes.jobs_path(data));
    if (keyword.length != 0) {
      if (url.split("?").length > 1) {
        url = [Routes.jobs_path({keyword: keyword}), url.split("?")[1]].join("&");
      } else {
        url = Routes.jobs_path({keyword: keyword});
      }
    }
    return url;
  }

  function getSearchConditions() {
    let inputs = $(".new_job_search_form_hover").find('input[type="checkbox"]:checked');
    let data = {};
    $.each(inputs, function (_, input) {
      if (data[input.dataset.name]) {
        data[input.dataset.name] += "," + input.value;
      } else {
        data[input.dataset.name] = input.value;
      }
    });
    if ($('#job_search_form_keyword').val() != "") {
      data['keyword'] = $('#job_search_form_keyword').val()
    }
    if ($('#show_release_job').is(":checked")) {
      data['showReleaseJob'] = true
    }
    if ($('#sort_select').val() != 'new') {
      data['sort'] = $('#sort_select').val()
    }
    if ($('#per_page').val() != 30) {
      data['per_page'] = $('#per_page').val()
    }
    console.log('data', data)

    return data;
  }

  function performSearch() {
    const formData = $(".new_job_search_form_hover").serializeArray();

    $.ajax({
      url: '/jobs/count',
      type: 'GET',
      data: formData,
      dataType: 'json'
    }).done(function (data) {
      const { job_count } = data;
      // $("#job_count").html(job_count?.toLocaleString())
      $("#job_count_modal_hover").html(job_count?.toLocaleString())
      // $("#job_count_modal").html(job_count?.toLocaleString())
      // $("#job_count_modal_skill").html(job_count?.toLocaleString())
    });
  }

  $('.search-modal-jobs_hover input[type="checkbox"]').change(function() {
    performSearch();
  });

  $(document).on('click', '.search_form_modal_btn_hover', function(){
    let data = getSearchConditions();
    let newUrl = decodeURIComponent(Routes.jobs_path(data));

    window.location.href = newUrl;
  });

  $(document).on('click', '.reset_form_modal_hover, .header_reset_btn_sp', function(e) {
    $(".search-modal-jobs_hover").find('input[type="checkbox"]').prop("checked", false);
    performSearch();
  })

  // handle on sp
  $(document).on('click', '.header_menu_mobile .menu_mobile#search_modal_sp', function(e) {
    $(".modal_hover_search_job").modal('show');
  });

  $(document).on('click', '.header_content a', function(e) {
    $(this).attr('data-turbolinks', false);
  });

  $(document).on('click', '.open_modal_search_job_sp', function(){
    $(this).closest(".category_container").find(".category_container_item.active").removeClass('active');
    $(this).addClass('active');
    const dataTab = $(this).data('tab');
    $(".modal_hover_search_job_sp .category_container").find(".category_container_item.active").removeClass('active');
    $(".modal_hover_search_job_sp .category_container").find('button[data-tab="' + dataTab + '"]').addClass('active');

    $(".modal_hover_search_job_sp .modal_content").find(".tab-pane.show.active").removeClass('active').removeClass('show');
    $(".modal_hover_search_job_sp .modal_content").find('.tab-pane[data-tab="'+ dataTab +'"]').addClass('active').addClass('show');
    $(".modal_hover_search_job_sp").modal('show')
  });


  $(document).on('click', '.modal_hover_search_job_sp .header_category_container button', function(){
    const dataTab = $(this).data('tab');
    $(".modal_hover_search_job_sp .category_container").find(".category_container_item.active").removeClass('active');
    $(".modal_hover_search_job_sp .category_container").find('button[data-tab="' + dataTab + '"]').addClass('active');

    $("#job_search_category_sp").find(".category_container_item.active").removeClass('active');
    $("#job_search_category_sp").find('button[data-tab="' + dataTab + '"]').addClass('active');
  });

});
